import React from 'react';
import { JxTooltip, JxTooltipRowItemDescription } from '@jx';
import outputMsgEngine from '../../../Widgets/OutputMsgWidget/Core/OutputMsgEngine.js';
import { DEBUG_LOGGING_ENABLED } from '../../../services/utils/debugMode.js';
import './UmlConnectorPointHandle.css';

// Zelfde clamp-conventie als shape-drag (UmlShapeWidgetBasehandleDragMouseDownHelper.jsx)
// — alleen een ondergrens. No upper bound: de canvas is een onbegrensde,
// pannable/zoomable wereld, dus clampen tegen window.innerWidth/innerHeight
// vergelijkt een wereld-coordinaat met een SCHERM-pixelaantal, wat zinloos is
// zodra er gepand/gezoomd is (zelfde root cause als de shape-drag-fix van
// 2026-07-10 — deze plek had 'm nooit meegekregen).
function clampCoord(value) {
    return Math.max(0, value);
}

class UmlConnectorPointHandle extends React.Component {
    handleMouseDown = (e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();

        const point = this.props.point;
        const startWorld = this.props.toWorldPoint(e.clientX, e.clientY);
        const offsetX = startWorld.x - point.x;
        const offsetY = startWorld.y - point.y;

        point.select();

        if (DEBUG_LOGGING_ENABLED) {
            outputMsgEngine.addMsg('Debug', 'log', `${point.id.slice(0, 8)} | Waypoint | mousedown | x:${Math.round(point.x)} y:${Math.round(point.y)}`);
        }

        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'grabbing';

        const onMouseMove = (ev) => {
            ev.stopImmediatePropagation();
            const worldPoint = this.props.toWorldPoint(ev.clientX, ev.clientY);
            if (this.props.onPointMoved) {
                const x = clampCoord(worldPoint.x - offsetX);
                const y = clampCoord(worldPoint.y - offsetY);
                this.props.onPointMoved(point.id, x, y);
            }
        };

        const onMouseUp = () => {
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
            if (DEBUG_LOGGING_ENABLED) {
                outputMsgEngine.addMsg('Debug', 'log', `${point.id.slice(0, 8)} | Waypoint | mouseup | x:${Math.round(point.x)} y:${Math.round(point.y)}`);
            }
            window.removeEventListener('mousemove', onMouseMove, true);
            window.removeEventListener('mouseup', onMouseUp, true);
        };

        window.addEventListener('mousemove', onMouseMove, true);
        window.addEventListener('mouseup', onMouseUp, true);
    };

    handleKeyDownWhileHovered = (e) => {
        if (e.key.toLowerCase() !== 'd') return;
        this.props.onPointRemove?.(this.props.point.id);
    };

    handleMouseEnter = () => {
        window.addEventListener('keydown', this.handleKeyDownWhileHovered, true);
    };

    handleMouseLeave = () => {
        window.removeEventListener('keydown', this.handleKeyDownWhileHovered, true);
    };

    componentWillUnmount() {
        // Vangnet: als het punt verdwijnt (bv. weggesleept/verwijderd) terwijl de
        // muis er nog op staat, mouseleave vuurt dan mogelijk niet meer.
        window.removeEventListener('keydown', this.handleKeyDownWhileHovered, true);
    }

    render() {
        return (
            <JxTooltip title={<JxTooltipRowItemDescription label="Press D" value="Remove waypoint" />}>
                <div
                    className="uml-connector-point-handle"
                    onMouseDown={this.handleMouseDown}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                />
            </JxTooltip>
        );
    }
}

export default UmlConnectorPointHandle;
